import { Component, OnInit } from "@angular/core";
import {
  QuotingContextData,
  SelectedCarrier,
} from "../model/quoting-context.model";
import { DataService } from "../shared/services/data.service";
import { AuthorizationService } from "../authorization/authoriation.service";
import { Router, ActivatedRoute } from "@angular/router";
import { RateTableRequest } from "../model/rateTableRequest.model";
import { RateTableInfo } from "../model/rateTableInformation.model";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "src/environments/environment";
import { CarrierLogoRequest } from "../model/carrier.model";

@Component({
  selector: "app-carrier",
  templateUrl: "./carrier.component.html",
  styleUrls: ["./carrier.component.css"],
})
export class CarrierComponent implements OnInit {
  carriers: any;
  requestData: QuotingContextData;
  rateTableRequest: RateTableRequest = new RateTableRequest();
  rateTableInfo: RateTableInfo = new RateTableInfo();
  groupData: any = {};
  stateId: number = 0;
  selectedCarrier: any = {};
  brokerState = localStorage.getItem("broker_state");
  Id: number = 0;
  isCarrierSelect: boolean = false;
  carriersLogos: any;
  carrierLogoRequest: CarrierLogoRequest = new CarrierLogoRequest();

  constructor(
    public dataService: DataService,
    private spinner: NgxSpinnerService,
    public authService: AuthorizationService,
    private route: ActivatedRoute,
    public router: Router
  ) {
    this.Id = Number(this.dataService.getValueFromRoute(this.route, "Id"));
  }

  ngOnInit() {
    this.spinner.show();
    this.getRatetable();
  }
  getRatetable(): any {
    this.dataService.getRateTableDatabyId(this.Id).subscribe((result) => {
      if (result) {
        this.rateTableRequest = result;
        this.rateTableInfo = JSON.parse(this.rateTableRequest.RequestJson);

        this.GetCarriers();
      }
    });
  }
  GetCarriers() {
    this.requestData = new QuotingContextData();
    this.requestData.CoverageType = 1;
    this.requestData.QuoteClassificationType = 1;
    this.requestData.EffectiveDate = this.rateTableInfo.Group.EffectiveDate;
    this.requestData.SicCode = this.rateTableInfo.Group.SicCode;
    this.requestData.EmployerZipCode = this.rateTableInfo.Group.ZipCode;
    this.requestData.State = this.rateTableInfo.Group.StateCode;
    this.requestData.Segment = 2;
    this.requestData.UserRole = this.authService.userRole;
    this.requestData.EmployerCountyCode = this.rateTableInfo.Group.CountyCode;
    this.requestData.QuoteType = 3;
    this.dataService
      .getActiveCarriers(this.requestData)
      .subscribe((result: any) => {
        if (result && result.AvailableActiveCarriers.length > 0) {
          this.carriers = result;
          this.carriers.AvailableActiveCarriers = this.sortCarriers(
            this.carriers.AvailableActiveCarriers
          );
          if (
            this.rateTableInfo.Carrier.nqsCarrierId != undefined &&
            this.rateTableInfo.Carrier.nqsCarrierId != ""
          ) {
            this.isCarrierSelect = true;
            this.selectedCarrier.CarrierName =
              this.rateTableInfo.Carrier.CarrierName;
            this.selectedCarrier.CarrierId = Number(
              this.rateTableInfo.Carrier.nqsCarrierId
            );
          }
          if (
            this.selectedCarrier.CarrierId ||
            this.rateTableInfo.Carrier.nqsCarrierId
          ) {
            this.dataService.activateNetworkNav.next(true);
          }
          this.spinner.hide();
        }
      });
  }
  sortCarriers(carriers) {
    return carriers.sort((carrier1, carrier2) =>
      carrier1.CarrierName > carrier2.CarrierName ? 1 : -1
    );
  }

  selectCarrier(carrier) {
    if (carrier) {
      if (this.selectedCarrier.CarrierId != carrier.CarrierId) {
        this.rateTableInfo.IsAllPackagePlans = false;
      }
      this.isCarrierSelect = true;
      this.selectedCarrier.CarrierName = carrier.CarrierName;
      this.selectedCarrier.CarrierId = carrier.CarrierId;
      this.GetCarrierLogoDetail(carrier.CarrierId);
    }
  }
  private GetCarrierLogoDetail(carrierId: number) {
    this.carrierLogoRequest.CarrierIds = [carrierId];
    this.dataService
      .getCarrierLogoDetails(this.carrierLogoRequest)
      .subscribe((data) => {
        if (data.length > 0) {
          const carrierLogosUrl = environment.apiEndPoints.carrierLogosUri;
          this.rateTableInfo.Carrier.CarrierImageUriForExcel =
            carrierLogosUrl + data[0].Path;
          if (data[0].ImageMimeType === "image/png") {
            this.rateTableInfo.Carrier.CarrierImageUri = `data:image/png;base64,${data[0].ImageData}`;
          } else {
            this.BindLogoInCarrierModel(data[0].Path);
          }
        }
      });
  }
  private BindLogoInCarrierModel(logoPath: string) {
    this.dataService.getCarrierLogoFilePath(logoPath).subscribe((data) => {
      if (data.length > 0) {
        const base64Svg = this.convertSvgToBase64(data);
        this.rateTableInfo.Carrier.CarrierImageUri = base64Svg;
      }
    });
  }

  convertSvgToBase64(svgString: string): string {
    // Encode the SVG string to Base64
    const base64 = btoa(unescape(encodeURIComponent(svgString)));
    // Create a data URL
    return `data:image/svg+xml;base64,${base64}`;
  }

  saveCarrierInfo() {
    if (this.selectedCarrier.CarrierId > 0) {
      this.isCarrierSelect = true;
      this.spinner.show();
      // need to re-confirm
      this.rateTableInfo.Carrier.CarrierName = this.selectedCarrier.CarrierName;
      this.getNetworkDetail();
    } else {
      this.isCarrierSelect = false;
    }
  }

  getNetworkDetail(): any {
    let selectedCarrierObj = this.carriers.AvailableActiveCarriers.find(
      (z) => z.CarrierId == this.selectedCarrier.CarrierId
    );
    if (selectedCarrierObj) {
      this.requestData.SelectedCarrier = selectedCarrierObj;
      let selectedCarrierId =
        selectedCarrierObj.CarrierId != null
          ? selectedCarrierObj.CarrierId
          : "";
      this.dataService
        .getNetworkDetail(this.requestData)
        .subscribe((result: any) => {
          if (result) {
            this.rateTableInfo.Carrier.nqsCarrierId =
              this.selectedCarrier.CarrierId;
            this.rateTableInfo.Carrier.CarrierName =
              this.selectedCarrier.CarrierName;
            this.rateTableInfo.Carrier.networks = Array.prototype.map
              .call(result.Networks, (c) => c.NetworkId)
              .toString();
            this.rateTableRequest.RequestJson = JSON.stringify(
              this.rateTableInfo
            );
            this.dataService
              .saveRateTableInfo(this.rateTableRequest)
              .subscribe((result) => {
                this.dataService.activateNetworkNav.next(true);
                if (result && Number(result) > 0) {
                  {
                    this.router.navigateByUrl("/plans/" + result);
                  }
                }
              });
          }
        });
    }
  }
}
